// extracted by mini-css-extract-plugin
export default {"button":"Fm-z","reviewSort":"Gm-z"};